module.exports = __webpack_public_path__ + "img/UTANAS-2.96602af9.jpg";